// extracted by mini-css-extract-plugin
export default {"selectorContainer":"simpleSelector_selectorContainer__MlEF0","selector":"simpleSelector_selector__UYyFP"};